import { appStatusStore } from '@/stores'
import { AppForms, Chat } from '@/config'
import { GroupFormModalPage, GroupFormModalPageProps } from '../../GroupFormModalPage'
import { useMemo } from 'react'
import { deepEqual } from '@codeleap/utils'
import { GroupDetailsModalProps } from '../index'

export const EditGroup = (props: GroupFormModalPageProps & GroupDetailsModalProps) => {
  const initialState = useMemo(() => AppForms.chatGroup.state.get(), [])
  const currentState = AppForms.chatGroup.use(f => f.values)
  const isValid = AppForms.chatGroup.use(s => s.isValid)

  const canSave = useMemo(() => {
    if (currentState?.name?.length === 0) return false

    const areFieldsChanged = !deepEqual(initialState, currentState)
    return areFieldsChanged && isValid
  }, [currentState, initialState, isValid])

  async function handleEdit() {
    try {
      appStatusStore.set('loading')
      const formValues = AppForms.chatGroup.state.get()

      const response = await Chat.Services.updateGroup(
        props.channel.id,
        {
          name: formValues.name,
          image: formValues.file?.file,
        },
        {
          name: initialState.name,
        },
      )

      if (response.ok) {
        await props.channel.watch()
        AppForms.chatGroup.resetValues()
      }

      props?.toggle?.()
    } catch (error) {
      logger.log('Error creating Group:', error)
    } finally {
      appStatusStore.set('idle')
    }
  }

  return (
    <GroupFormModalPage
      {...props}
      title='Edit group'
      membersShown={false}
      toggle={() => {
        props?.toggle?.()
        AppForms.chatGroup.resetValues()
      }}
      onPrevPage={() => {
        AppForms.chatGroup.resetValues()
        props.navigateTo('group_info')
      }}
      buttonProps={{
        debugName: 'EditGroup:Save',
        text: 'Save',
        onPress: handleEdit,
        disabled: !canSave,
      }}
    />
  )
}
